<template>
    <div>
        <app-filepicker
            label="Bild"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.slides.' + listitemId + '.data.image'
            "
            required
            accept=".jpg,.png,.gif"
            :show-focus="true"
            :show-transparency="false"
            :show-scaling-mode="true"
        ></app-filepicker>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Filepicker from '@/components/fields/complex/Filepicker.vue';
import { EventBus } from '@/helpers/event-bus';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['getProp', 'hasPackageBasic'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R088'),
            help: this.$helpers.uiText('R085'),
            removeText: this.$helpers.uiText('R090'),
            showGlobal: false
        });
        EventBus.$emit('slider-goto', {
            id: this.listitemId
        });
    },
    props: {
        moduleId: String,
        listitemId: String
    },
    components: {
        'app-filepicker': Filepicker
    }
};
</script>
